import {HttpClient$, POST, expectEither} from '@raison/network-facade';
import {TypeOf, string, type} from 'io-ts';
import {atom} from 'jotai';
import {SmsPin} from '~/shared/api/legacy_services/wallets';

export const Get2FASchema = type({
    key: string,
});
export type Get2FASchema = TypeOf<typeof Get2FASchema>;

export const get2FA = atom(get => async (data: SmsPin) => {
    const http = get(HttpClient$);
    return await http('/v1/2fa/get', POST(data)).then(
        ...expectEither({
            200: Get2FASchema,
            400: type({message: string}),
        })
    );
});
